import Vue from "vue";

export async function fethNotifications({ commit }, data) {
  let userType = data.userIsAparent ? "parent" : "child"
  let url = `/${userType}/${data.userId}/notifications/`
  await Vue.axios({
    method: "GET",
    url: url
  }).then((response) => {
    commit("updateNotifications", response.data)
  }).catch((error) => {
    commit("error", error.message)
  })
}

export async function markAsRead({ commit }, notId) {
  commit("markAsReadNotification", notId)
  await Vue.axios({
    method: "POST",
    url: `/notification/${notId}/mark_read/`,
    data: {
      unread: false
    }
  })
}

export async function dissmissNotification({ commit }, notId) {
  commit("removeNotification", notId)
  await Vue.axios({
    method: "DELETE",
    url: `/notification/${notId}/dismiss/`
  })
}

export async function dissmissAllNotifications({commit},{ userId,isAparent}){
  commit("removeAllNotifications")
  await Vue.axios({
    method: "DELETE",
    url: isAparent?`parent/${userId}/dismiss_notifications/`:`child/${userId}/dismiss_notifications/`
  })
}